import React from "react";
import {
  NewTab,
  PageHeader,
  PageTab,
  PageTabAdv,
  PageTitle,
} from "../../../components";
import AllBills from "./AccountsPayable/AllBills";
import Payments from "./AccountsPayable/Payments";
import DraftBills from "./AccountsPayable/DraftBills";
import OpenBills from "./AccountsPayable/OpenBills";
import WorkList from "./AccountsPayable/WorkList";
import WaitingforApproval from "./AccountsPayable/WaitingforApproval";
import PaidBills from "./AccountsPayable/PaidBills";
import Rejected from "./AccountsPayable/Rejected";
import ApDashboard from "./AccountsPayable/ApDashboard";
const AccountsPayable = () => {
  const accountspayablemenu = [
    {
      title: "AP Dashboard",
      page: <ApDashboard />,
      type: "main",
    },
    {
      title: "All Bills",
      page: <AllBills />,
      type: "main",
    },
    {
      title: "Payments",
      page: <Payments />,
      type: "main",
    },
    {
      title: "Open Bills",
      page: <OpenBills />,
      type: "main",
    },
    {
      title: "Draft Bills",
      page: <DraftBills />,
      type: "main",
    },
    // removed as discussed with chandan sir
    // {
    //   title: " Work List",
    //   page: < WorkList />,
    //   type: "main",
    // },
    {
      title: " Waiting for Approval",
      page: <WaitingforApproval />,
      type: "main",
    },
    {
      title: "Rejected",
      page: <Rejected />,
      type: "main",
    },
    // {
    //   title: "Paid Bills",
    //   page: <PaidBills />,
    //   type: "main",
    // },
    {
      title: "Create Account Payable Invoice",
      link: "/accounts-payable/Invoice",
      type: "sub",
      icon: " ",
    },
    {
      title: "Accounts Payable Settings",
      link: "/accounts-payable/settings",
      type: "sub",
      icon: " ",
    },
    {
      title: "Quickbooks Integration",
      link: "/quickbooks",
      type: "sub",
      icon: "newsstand",
    },
  ];

  return (
    <>
      <PageHeader
        Section={
          <div className="flex my-3">
            <PageTitle title={"AP Management"} tag="h5" />
          </div>
        }
      />
      <NewTab
        tabs={accountspayablemenu}
        color="black"
        variant="outlined"
        mode="url"
        tabId="accounts-payable"
      />
    </>
  );
};

export default AccountsPayable;
